import React from 'react';
import Tab from './Tab';

const Tabs = props => {
  const { type, width, borderColor, tabList, toggleTab, activeTab } = props;
  return (
    <div id="tab-header" className={type || ''}>
      {tabList.map(
        (tab, index) =>
          tab.title && (
            <Tab
              key={tab.title}
              title={tab.title}
              type={type}
              active={activeTab === index}
              index={index}
              count={tab.count}
              toggleTab={toggleTab}
              width={width}
              enabled={tab.enabled}
              borderColor={borderColor}
            />
          )
      )}
    </div>
  );
};

export default Tabs;
